module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "500px",
      "persistent": ""
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.showTitle))]), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-3 body-2"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.checkLists)
    }
  }), _vm._v(" "), (_vm.dateCol === 'overallAlignmentCol') ? _c('div', [_c('div', {
    staticClass: "d-flex flex-row"
  }, [_c('p', {
    staticClass: "mb-0 pt-3 pr-2"
  }, [_vm._v("Alignment Sync Date - ")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "edit-date-box",
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": ""
    },
    on: {
      "input": function($event) {
        return _vm.checkDate(_vm.alignmentSyncDate)
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.checkDate(_vm.alignmentSyncDate)
      }
    },
    model: {
      value: (_vm.alignmentSyncDate),
      callback: function($$v) {
        _vm.alignmentSyncDate = $$v
      },
      expression: "alignmentSyncDate"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "date-picker-inner"
  }, [_c('date-picker', {
    attrs: {
      "className": "input-field",
      "options": {
        theme: 'icon'
      },
      "status": _vm.dateCal
    },
    on: {
      "changeDate": _vm.setDateFromPicker
    }
  })], 1)], 1), _vm._v(" "), (_vm.alignementSyncErr) ? _c('span', {
    staticClass: "text-danger ma-0 pt-1"
  }, [_vm._v("Please enter valid Alignment Sync Date")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.dateCol === 'approvedByAdminCol') ? _c('div', [_c('p', {
    staticClass: "subtitle-1 font-weight-bold mb-2"
  }, [_vm._v("Please check and confirm these steps below")]), _vm._v(" "), _c('ol', {
    staticClass: "text-left body-1"
  }, [_c('li', [_vm._v("Stats and Sentiment Due Date - "), _c('b', [_vm._v(_vm._s(_vm.item.SentimentDateCol && _vm.item.SentimentDateCol.status ? 'Ready' : 'Not Ready!'))])]), _vm._v(" "), _c('li', [_vm._v("Completed by CC - "), _c('b', [_vm._v(_vm._s(_vm.item.CCReadyDeckCol && _vm.item.CCReadyDeckCol.status ? 'Ready' : 'Not Ready!'))])]), _vm._v(" "), _c('li', [_vm._v("Completed by AM - "), _c('b', [_vm._v(_vm._s(_vm.item.AMReadyDeckCol && _vm.item.AMReadyDeckCol.status ? 'Ready' : 'Not Ready!'))])]), _vm._v(" "), _c('li', [_vm._v("Alignment Sync - "), _c('b', [_vm._v(_vm._s(_vm.item.overallAlignmentCol && _vm.item.overallAlignmentCol.status ? ("Ready (" + (_vm.item.overallAlignmentCol.alignmentDate) + ")") : 'Not Ready!'))])])]), _vm._v(" "), (_vm.item.SentimentDateCol && _vm.item.SentimentDateCol.reviewDateURL) ? _c('div', {
    staticClass: "pl-2"
  }, [_c('p', {
    staticClass: "mb-0 subtitle-2"
  }, [_vm._v("Review Deck URL")]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.item.SentimentDateCol.reviewDateURL
    }
  }, [_vm._v(_vm._s(_vm.item.SentimentDateCol.reviewDateURL))])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "id": "close",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green",
      "text": "",
      "disabled": !_vm.isConfirmAllowed
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Confirm")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f3b8bfc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/ReviewMeeting/ReviewMeetingChecklistModal.vue
// module id = 2092
// module chunks = 0